module.exports = __webpack_public_path__ + "static/media/NeverWinterLogo.7f37fc13.webp";